import React from "react"

import Spacing from "@irati/ui/src/Spacing"
import {Body} from "@irati/ui/src/Typography"
import {ButtonLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"

import FormattedMessage from "@irati/utils/lang"
import {Deal} from "@irati/types"
import {Background} from "../styled"

interface Props {
  id?: string,
  deal: Deal
}

const ExternalURLCTA: React.FC<Props> = ({deal}) => {
  const {brandName} = deal

  return (
    <Background>
      <Spacing padding={[3, 1]}>
        <Body small paddingBottom={1.5} textAlign="center">
          <FormattedMessage id="perks.importantInfoBlock.externalURLCTA.header" values={{brandName}} />
        </Body>
        <Flex justifyContent="center">
          <ButtonLink primary target="_blank" href={deal.externalLoginUrl}>
            <FormattedMessage id="perks.importantInfoBlock.externalURLCTA.buttonText" />
          </ButtonLink>
        </Flex>
      </Spacing>
    </Background>
  )
}

export default ExternalURLCTA
